import React, {RefObject} from "react";
import {connect} from "react-redux";
import {DisplayType, EditorType, Nullable} from "@data-force/app";
import classNames from "classnames";
import "./TasksSection.scss";
import StoreState from "../../interfaces/store/storeState";
import SingleTask from "./SingleTask/SingleTask";
import HistoryParams from "../../interfaces/historyParams";
import {getHistoryParams} from "../../utils/common";
import TasksWizard from "./TasksWizard/TasksWizard";
import TasksScroll from "./TasksScroll/TasksScroll";

interface StateProps {
    displayType: DisplayType
}

interface OwnProps {
    headerReference: RefObject<HTMLDivElement>
    alert?: React.ReactNode
}

type Props = StateProps & OwnProps;

class TasksSection extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.createContent = this.createContent.bind(this);
    }

    createContent(): React.ReactNode {
        const {displayType, headerReference}: Props = this.props;
        let content: React.ReactNode = null;
        switch (displayType) {
            case DisplayType.DICTATION:
                content = <SingleTask headerReference={headerReference}/>;
                break;
            case DisplayType.INTAKER_WIZARD:
                content = <TasksWizard/>;
                break;
            case DisplayType.INTAKER_SCROLL:
                content = <TasksScroll/>;
                break;
            default:
                break;
        }
        return content;
    }

    render() {
        const {displayType, alert}: Props = this.props;
        const tasksSectionClass: string = classNames({
            "df-dictation-tasks-section": displayType === DisplayType.DICTATION,
            "df-intaker-tasks-section": displayType === DisplayType.INTAKER_WIZARD
                || displayType === DisplayType.INTAKER_SCROLL,
        });

        return (
            <div className={tasksSectionClass}>
                {alert}
                {this.createContent()}
            </div>
        );
    }
}

function mapStateToProps({
    project,
    schema: {parsedSchemas},
}: StoreState): StateProps {
    const historyParams: Nullable<HistoryParams> = getHistoryParams();
    const schemaKey: string = `${project.projectDetails?.schemaId}_${historyParams?.phase}`;
    const editor: EditorType = parsedSchemas[schemaKey] as EditorType;

    return {
        displayType: editor?.layout || DisplayType.INTAKER_WIZARD,
    };
}

export default connect(mapStateToProps)(TasksSection);
